import store from "@/store";
import Roles from "@/enums/Roles";

const AuthorizationUtils = {
  isGranted(askedPermission) {
    const _askedPermission = askedPermission.toString();

    try {
      if (!_askedPermission) return false;

      if (_askedPermission === "*") return true;

      let result = false;

      const isOrCombination = _askedPermission.includes("|");
      if (isOrCombination) {
        const askedPermissions = _askedPermission
          .split("|")
          .map((perm) => perm);

        result = askedPermissions.some((askedPerm) => {
          result =
            (askedPerm == Roles.CLIENT && this.isClient()) ||
            (askedPerm == Roles.ADMIN && this.isAdmin());

          return true;
        });
      } else {
        result =
          (_askedPermission == Roles.CLIENT && this.isClient()) ||
          (_askedPermission == Roles.ADMIN && this.isAdmin());
      }

      return result;
    } catch (error) {
      return false;
    }
  },
  isAdmin() {
    return !store.getters["Auth/getLoggedInUser"]?.cl;
  },
  isClient() {
    return store.getters["Auth/getLoggedInUser"]?.cl;
  },
};

export default AuthorizationUtils;
